(function () {
  // Inject CSS once
  if (!document.getElementById('ela-wl-styles')) {
    var s = document.createElement('style');
    s.id = 'ela-wl-styles';
    s.textContent =
      '.card__inner{position:relative;}' +
      '.ela-wl-btn{background:rgba(255,255,255,.92);border:none;cursor:pointer;padding:0;display:inline-flex;align-items:center;justify-content:center;transition:transform .15s,background .15s;border-radius:50%;}' +
      '.ela-wl-btn svg{stroke:#aaa;fill:none;transition:stroke .2s,fill .2s;}' +
      '.ela-wl-btn.is-active svg{stroke:#E86098;fill:#E86098;}' +
      '.ela-wl-btn--card{position:absolute;top:.6rem;right:.6rem;z-index:5;width:34px;height:34px;box-shadow:0 2px 8px rgba(0,0,0,.14);}' +
      '.ela-wl-btn--card:hover{background:#fff;transform:scale(1.1);}' +
      '.ela-wl-btn--card .ela-wl-icon svg{width:16px;height:16px;}' +
      '.ela-wl-btn--product{width:100%;margin-top:.75rem;padding:.75rem 1rem;border-radius:6px;border:1.5px solid #e0e0e0;background:#fafafa;gap:.55rem;font-family:inherit;font-size:.82rem;font-weight:600;letter-spacing:.04em;color:#666;transition:border-color .2s,color .2s,background .2s;}' +
      '.ela-wl-btn--product:hover{border-color:#E86098;color:#E86098;background:#fff5f9;}' +
      '.ela-wl-btn--product.is-active{border-color:#E86098;color:#E86098;background:#fff0f6;}' +
      '.ela-wl-btn--product .ela-wl-icon{display:flex;align-items:center;}' +
      '.ela-wl-btn--product .ela-wl-icon svg{width:18px;height:18px;}';
    document.head.appendChild(s);
  }

  var KEY = 'ela_wishlist_v1';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isIn(id) {
    return getList().some(function (i) { return String(i.id) === String(id); });
  }
  function toggle(product) {
    var list = getList();
    var idx = -1;
    for (var x = 0; x < list.length; x++) {
      if (String(list[x].id) === String(product.id)) { idx = x; break; }
    }
    if (idx > -1) { list.splice(idx, 1); } else { list.push(product); }
    saveList(list);
    return idx === -1; // true = added
  }

  function applyState(btn, active) {
    if (active) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-label', 'Quitar de lista de deseos');
      var lbl = btn.querySelector('.ela-wl-label');
      if (lbl) lbl.textContent = 'Guardado en mi lista ✓';
    } else {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-label', 'Guardar en mi lista de deseos');
      var lbl = btn.querySelector('.ela-wl-label');
      if (lbl) lbl.textContent = 'Guardar en mi lista de deseos';
    }
  }

  function syncAll(id, active) {
    document.querySelectorAll('.ela-wl-btn[data-product-id="' + id + '"]').forEach(function (b) {
      applyState(b, active);
    });
  }

  function initButtons() {
    document.querySelectorAll('.ela-wl-btn[data-product-id]').forEach(function (btn) {
      var id = btn.dataset.productId;
      applyState(btn, isIn(id));
      if (btn.dataset.elaWlBound) return;
      btn.dataset.elaWlBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var product = {
          id: btn.dataset.productId,
          title: btn.dataset.productTitle || '',
          price: btn.dataset.productPrice || '',
          image: btn.dataset.productImage || '',
          url: btn.dataset.productUrl || ''
        };
        var added = toggle(product);
        syncAll(id, added);
      });
    });
  }

  function renderPage() {
    var container = document.getElementById('ela-wishlist-grid');
    if (!container) return;
    var list = getList();
    if (list.length === 0) {
      container.innerHTML =
        '<div class="ela-wl-empty">' +
        '<p>Tu lista de deseos está vacía.</p>' +
        '<a href="/collections/all" class="ela-wl-empty__cta">Ver colección</a>' +
        '</div>';
      return;
    }
    var html = '';
    list.forEach(function (item) {
      html += '<div class="ela-wl-card">';
      html += '<a href="' + item.url + '" class="ela-wl-card__img-wrap">';
      if (item.image) {
        html += '<img src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy">';
      }
      html += '</a>';
      html += '<div class="ela-wl-card__info">';
      html += '<h3 class="ela-wl-card__name"><a href="' + item.url + '">' + (item.title || '') + '</a></h3>';
      if (item.price) html += '<p class="ela-wl-card__price">' + item.price + '</p>';
      html += '<div class="ela-wl-card__actions">';
      html += '<a href="' + item.url + '" class="ela-wl-card__btn">VER PRODUCTO</a>';
      html += '<button class="ela-wl-remove" data-id="' + item.id + '" type="button">Quitar</button>';
      html += '</div>';
      html += '</div></div>';
    });
    container.innerHTML = html;
    container.querySelectorAll('.ela-wl-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        saveList(getList().filter(function (i) { return String(i.id) !== String(btn.dataset.id); }));
        renderPage();
      });
    });
  }

  window.ElaWishlist = { getList: getList, renderPage: renderPage, initButtons: initButtons };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initButtons(); renderPage(); });
  } else {
    initButtons();
    renderPage();
  }
})();
